var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","fillOpacity":"1","strokeWidth":"0.2","strokeLinejoin":"round","d":"M 11,4L 13,4L 13,16.0104L 18.5052,10.5052L 19.9194,11.9194L 12,19.8388L 4.08058,11.9194L 5.49479,10.5052L 11,16.0104L 11,4 Z "}));
}

ArrowDown.defaultProps = {"version":"1.1","baseProfile":"full","width":"24","height":"24","viewBox":"0 0 24.00 24.00","enableBackground":"new 0 0 24.00 24.00","xmlSpace":"preserve"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
